// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crud-form-group input.crud-input[data-v-159ed05c] {\n  background: #001f33;\n  color: white;\n  border: 1px solid white;\n  border-radius: 4px;\n}\n.crud-form-group input.crud-input[data-v-159ed05c]:focus {\n  outline: none;\n  border: 1px solid #00bcd4;\n}", ""]);
// Exports
module.exports = exports;
